var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#de384a",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2396 5109 c-434 -60 -811 -336 -995 -730 -83 -177 -116 -333 -116 -559 0 -151 2 -169 23 -216 58 -128 210 -209 344 -184 105 20 199 92 239 184 19 42 24 78 30 206 5 119 12 170 29 220 91 270 335 450 610 450 236 0 465 -141 568 -351 137 -277 78 -505 -176 -682 -197 -137 -408 -223 -817 -332 -570 -152 -781 -270 -840 -469 -13 -42 -15 -208 -15 -1146 0 -695 4 -1117 10 -1150 32 -170 170 -308 339 -340 73 -14 1789 -14 1862 0 170 32 308 171 339 342 7 36 9 666 7 1859 -3 1690 -4 1809 -21 1879 -66 277 -181 485 -370 668 -182 175 -391 286 -641 337 -96 20 -314 28 -409 14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorHanger);
export default __webpack_public_path__ + "static/media/door-hanger.0e1cec5d2cbc1dca91d5b18486ab08a3.svg";
export { ForwardRef as ReactComponent };